<p-card class="p-3">
  <ng-template #header
    ><div>
      <i class="fa-solid fa-clock-rotate-left mr-3"></i>Controller history
    </div></ng-template
  >

  <p-fluid class="grid grid-cols-12 gap-3">
    <p-inputgroup class="col-span-12 md:col-span-3 lg:col-span-2 md:pr-10">
      <p-inputgroup-addon>
        <i class="fa-solid fa-calendar"></i>
      </p-inputgroup-addon>
      <p-floatlabel variant="on">
        <p-datepicker
          [(ngModel)]="logDate"
          name="logDate"
          id="logDate"
          [maxDate]="maxDate"
          [showButtonBar]="true"
          dateFormat="dd/mm/yy"
          required
          class="w-full md:w-80"
        />
        <label for="logDate">Date</label>
      </p-floatlabel>
    </p-inputgroup>

    <p-inputgroup class="col-span-12 md:col-span-5 lg:col-span-6">
      <p-inputgroup-addon>
        <i class="fa-solid fa-plug"></i>
      </p-inputgroup-addon>
      <p-floatlabel variant="on">
        <p-multiselect
          id="selectAssets"
          [(ngModel)]="chosenAssets"
          [options]="assetList"
          [group]="true"
          optionLabel="label"
          display="chip"
          scrollHeight="200px"
          [maxSelectedLabels]="undefined"
        >
          <ng-template let-group #group>
            <div class="flex items-center">
              <i class="{{ group.icon }} mr-3"></i>
              <span>{{ group.label }}</span>
            </div>
          </ng-template></p-multiselect
        >
        <label for="selectAssets">Asset(s)</label>
      </p-floatlabel>
    </p-inputgroup>

    <p-button
      label="Refresh"
      class="col-span-12 md:col-span-4"
      (click)="onSubmit()"
      icon="fa fa-rotate"
      [loading]="isLoading"
      iconPos="right"
      [disabled]="!logDate || chosenAssets.length == 0"
    />
  </p-fluid>

  <p-divider />

  <p-chart
    #historyChart
    type="line"
    [data]="data"
    [options]="options"
    class="h-[20rem] mb-15"
    [plugins]="options.pluginsArray"
  />

  <div class="float-right -mt-10">
    <p-button
      [class]="zoomEnabled ? 'inline-flex' : 'hidden'"
      type="button"
      label="Reset Zoom"
      icon="pi pi-refresh"
      (click)="resetZoom()"
    />
    <p-button
      [class]="showToggleZoom ? 'ml-5' : 'hidden'"
      type="button"
      [label]="zoomEnabled ? 'Disable Zoom' : 'Enable Zoom'"
      [icon]="zoomEnabled ? 'pi pi-search-minus' : 'pi pi-search-plus'"
      (click)="toggleZoom()"
    />
    <p-button
      [class]="showGridLimitsLinesBtn ? 'ml-5' : 'hidden'"
      type="button"
      [label]="
        showGridLimitsLines ? 'Remove grid-limit lines' : 'Add grid-limit lines'
      "
      [icon]="showGridLimitsLines ? 'fa-solid fa-eye-slash' : 'fa-solid fa-eye'"
      (click)="toggleGridLimitLine()"
    />
  </div>
</p-card>
